import React from 'react'
import { Container } from 'semantic-ui-react';
import "./Banner.scss"

export function Banner() {
    return (
        <div className='banner'>
            <Container >
                <h1>
                    Desarrolla tu creatividad en el mundo de la programación
                </h1>
                <h2>
                    Descubre un universo de posibilidades para crear proyectos de todo tipo y conviértete en un experto en programación y diseño web con nuestros cursos prácticos y actualizados en línea.
                </h2>
            </Container>

            <div className='banner__dark' />
        </div>
    )
}
